import * as React from 'react';
import { BrowserType, Dispatch, Store } from '../types';
import bowser from 'bowser';
import { Alert } from 'reactstrap';
import Icon from './Icons';
import { SUPPORTED_BROWSERS } from '../constants';
import { connect } from 'react-redux';
import { sessionSelector } from '../reducers/session';
import { SESSION_ACTIONS } from '../actions/session';

export type StoreProps = {
  isBrowserAlertClosed: boolean;
};

export type DispatchProps = {
  closeBrowserAlert: () => void;
};

export type OwnProps = {
  isClosable: boolean;
  iconSize: number;
};

export type Props = StoreProps & DispatchProps & OwnProps;

export class SupportedBrowserAlert extends React.Component<Props> {
  getBrowser = (): BrowserType => {
    const result = bowser.getParser(window.navigator.userAgent);
    return {
      name: result.getBrowserName(),
      version: parseInt(result.getBrowserVersion(), 10),
    };
  };

  getIsBrowserSupportedMessage = (): string => {
    // Change phrasing after January 1, 2020
    const browser = this.getBrowser();
    const browserName = browser.name as keyof typeof SUPPORTED_BROWSERS;
    const preMessage = 'Please use a newer browser to login. Arctic Wolf';
    if (SUPPORTED_BROWSERS[browserName] === 0) {
      return `${preMessage} does not support ${browserName}.`;
    } else if (SUPPORTED_BROWSERS[browserName] > browser.version) {
      return `${preMessage} does not support ${browser.name} ${
        SUPPORTED_BROWSERS[browserName] - 1
      } and earlier versions.`;
    } else {
      return '';
    }
  };

  makeMessageContent = (message: string) => {
    const { iconSize } = this.props;
    return (
      <div className="d-flex">
        <Icon.Exclamation size={iconSize} />
        <div className="pl-3">{message}</div>
      </div>
    );
  };

  render() {
    const { isClosable, isBrowserAlertClosed, closeBrowserAlert } = this.props;
    const message = this.getIsBrowserSupportedMessage();
    const messageContent = this.makeMessageContent(message);
    return message ? (
      <Alert
        isOpen={!isBrowserAlertClosed}
        toggle={!isClosable ? undefined : () => closeBrowserAlert()}
        color="warning"
      >
        {messageContent}
      </Alert>
    ) : null;
  }
}

export default connect<StoreProps, DispatchProps, OwnProps>(
  (store: Store): StoreProps => ({
    isBrowserAlertClosed: sessionSelector.isBrowserAlertClosed(store),
  }),
  (dispatch: Dispatch): DispatchProps => ({
    closeBrowserAlert: () => dispatch(SESSION_ACTIONS.CLOSE_BROWSER_ALERT()),
  }),
)(SupportedBrowserAlert);
